window.Popper = require('popper.js').default;
require('bootstrap');
